import axios from "const/axios";
import { useQuery } from "@tanstack/react-query";

export const useAllProviders = (enabled) => {
  const { data: providers = [] } = useQuery({
    queryKey: ["all-providers-aggregated"],
    queryFn: async () => {
      const res = await axios.get(`accounts/provider/aggregated`, {
        params: { page: 0, size: 1000 },
      });
      const raw = res?.data?.data;
      return Array.isArray(raw) ? raw : Array.isArray(raw?.content) ? raw.content : [];
    },
    enabled: !!enabled,
    refetchOnWindowFocus: false,
    staleTime: 45 * 1000,
  });

  return providers;
};
